// src/Components/NicheShared/NicheFeatures.tsx
import React from "react";
import styled from "styled-components";
import Container from "../Container";
import Row from "../Row";
import { Icon } from "@iconify/react";

export interface Feature {
  icon: string;
  title: string;
  description: string;
}

interface NicheFeaturesProps {
  features: Feature[];
  id?: string;
}

const SectionTitle = styled.h2`
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  margin-bottom: 48px;

  span {
    color: #e4da1b;
  }
`;

const FeatureCard = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 32px;
  border-radius: 14px;
  background-color: #111;
  border: 1px solid #222;
`;

const IconWrapper = styled.div`
  font-size: 32px;
  margin-right: 20px;
  flex-shrink: 0;
  color: #e4da1b;
`;

const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #e4da1b;
  margin: 0 0 8px;
`;

const CardDesc = styled.p`
  font-size: 14px;
  font-weight: 300;
  color: #ccc;
  line-height: 22px;
  margin: 0;
`;

const NicheFeatures: React.FC<NicheFeaturesProps> = ({ features, id }) => (
  <Container
    id={id}
    style={{ paddingTop: "80px", paddingBottom: "80px", background: "#000" }}
  >
    <SectionTitle>
      O que o <span>Alfred</span> faz pelo seu negócio
    </SectionTitle>
    <Row xs="1fr" sm="1fr 1fr" gap="24px">
      {features.map((f) => (
        <FeatureCard key={f.title}>
          <IconWrapper><Icon icon={f.icon} width={32} height={32} /></IconWrapper>
          <div>
            <CardTitle>{f.title}</CardTitle>
            <CardDesc>{f.description}</CardDesc>
          </div>
        </FeatureCard>
      ))}
    </Row>
  </Container>
);

export default NicheFeatures;
